var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("공지사항")])]), !_vm.$route.params._board && _vm.$route.query.mode !== 'input' ? [_c('v-tabs', {
    staticClass: "board-tabs",
    attrs: {
      "grow": "",
      "hide-slider": "",
      "show-arrows": false
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/notice"
    }
  }, [_vm._v("전체")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/notice/general"
    }
  }, [_vm._v("일반공지")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/notice/recruitment"
    }
  }, [_vm._v("인재채용")])], 1), _c('board-list', {
    attrs: {
      "code": [`general`]
    }
  })] : _vm.$route.query.mode === 'input' ? _c('board-write') : _c('board-view')], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }